import { QRCodeSVG } from "qrcode.react";

const QRCodeGenerator = ({ orderId }) => {
  return <QRCodeSVG value={orderId} size={200} level="H" />;
};

export default QRCodeGenerator;
